import { useContext, useEffect, useRef, useState } from "react";
import { MediaListItem as MediaListItemResp } from "@jconradi/tutu-porn-api-client/src/users"
import { VideoControls } from "./VideoControls";
import { MediaQuality, VideoPlayerContext, VideoPlayerContextProvider } from "./VideoPlayerContext";
import styles from "./VideoPlayer.module.css";
import cls from 'clsx';
import { FullScreen, useFullScreenHandle } from "react-full-screen";
import { VideoContainer } from "./VideoContainer";
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css'
import { MediaError } from "../../Errors/MediaError/MediaError";

export interface VideoPlayerProps {
    media: MediaListItemResp;
    autoPlayInView?: boolean;
    enableControls?: boolean;
    [rest: string]: any;
}
export const VideoPlayer = ({ media, autoPlayInView = false, enableControls = true, ...rest }: VideoPlayerProps) => {
    const screen = useFullScreenHandle();

    return (
        <VideoPlayerContextProvider autoPlayInView={autoPlayInView}>
            <FullScreen handle={screen}>
                <VideoContainer>
                    <Video media={media} enableControls={enableControls} {...rest} />
                    {enableControls && <VideoControls fullScreenHandle={screen} />}
                </VideoContainer>
            </FullScreen>

        </VideoPlayerContextProvider>
    )
}

export interface VideoProps {
    media: MediaListItemResp;
    enableControls?: boolean;
    [rest: string]: any;
}
const Video = ({ media, enableControls = true, ...rest } : VideoProps) => {
    const { playing, videoRef, setPlaying, setProgress, quality, adActive, vastTracker, setAdActive, triggerAd,
         adsPlayed, showControls, loaded, setLoaded, setIsError, isError } = useContext(VideoPlayerContext);
    const lastTime = useRef<number | undefined>();
    const totalWatchedTime = useRef<number>(0);

    const onTimeUpdate = (e: any) => {
        if (!videoRef.current) {
            return;
        }

        if (adActive) {
            vastTracker.setProgress(e.target.currentTime);
        }
        else if (playing) {
            // Get elapsed time user has been watching content
            if (lastTime.current) {
                const elapsed = videoRef.current.currentTime - lastTime.current;
                
                if (elapsed > 0 && elapsed < 2) {
                    totalWatchedTime.current += elapsed;
                }

                const totalWatchedNum = Math.floor(totalWatchedTime.current);
                // Trigger an ad every 2 minutes or after first 10 seconds of initial watch.
                if ((adsPlayed === 0 && totalWatchedNum > 10) || (adsPlayed > 0 && totalWatchedNum > 120)) {
                    // triggerAd();
                    totalWatchedTime.current = 0;
                }

                // MUST NOW MAKE ONLY A SINGLE VIDEO PLAY ON SCREEN AT A TIME SO WE'RE NOT SHOWING TOO MANY ADS AT ONCE.
                // MAKE IT MORE SMOOTH
    
            }
            lastTime.current = videoRef.current.currentTime;
        }

        const progress = (videoRef.current.currentTime / videoRef.current.duration) * 100;
        setProgress(progress);
    }

    const onMouseMove = () => {
        showControls();
    }

    const onClick = () => {
        if (adActive) {
            vastTracker.click();
        }
        else {
            if (enableControls) {
                setPlaying(!playing);
            }
        }
    }

    const onError = () => {
        if (adActive) {
            vastTracker.error();
        }

        setIsError(true);
    }

    const onCanPlay = () => {
        if (adActive) {
            vastTracker.load();
        }
    }

    const onEnded = () => {
        if (adActive) {
            vastTracker.complete();
            setAdActive(false)
        }
        else {
            setPlaying(false);
        }
    }

    const onVolumeChange = (e: any) => {
        if (adActive) {
            vastTracker.setMuted(e.target.muted);
        }
    }

    let src;

    if (adActive) {
        const { ad } = vastTracker;
        const creative = ad.creatives[0];
        const mediaFile = creative.mediaFiles[0];

        src = mediaFile.fileURL
    }
    else {
        src = quality === 'hd' && media.urls.hd ? media.urls.hd : (media.urls.sd);
    }

    return (
        <>
        <video src={src}
        onVolumeChange={onVolumeChange}
        onMouseMove={onMouseMove}
        onLoadedData={() => setLoaded(true)} 
        onLoadStart={() => setLoaded(false)} 
        onCanPlay={onCanPlay}
        onError={onError}
        onClick={onClick} 
        ref={videoRef} 
        loop={!adActive}
        autoPlay playsInline muted 
        onTimeUpdate={onTimeUpdate}
        onPlay={() => {
            setPlaying(true)
        }}
        onPlaying={() => {

        }} 
        onEnded={onEnded}
         className={cls("object-contain absolute inset-0 w-full h-full cursor-pointer", styles.video, {
            ['hidden']: !loaded || isError
         })} {...rest} />
         {!loaded && !isError && <Skeleton className="absolute inset-0 z-0" />}
         {isError && <MediaError /> }
         </>
    )
}